<template>
    <div>
        <application-title :title="$t('applications.score.title')">
            <application-button
                :condition="canManage"
                :title="hasScore ? $t('applications.score.update') : $t('applications.score.start')"
                icon="mood"
                @click="startReview"
            />
        </application-title>

        <div class="flex items-center">
            <div class="flex-grow flex items-center gap-12">
                <score :score="application.score" class="w-40 h-40"></score>
                <score-progress :score="application.score" class="h-12 w-full"></score-progress>
                <div class="text-body text-white px-12 py-8 leading-none flex items-center justify-center rounded"
                     :style="{ backgroundColor: application.scoreColor }">
                    <span class="font-semibold">{{ application.score === null ? '-' : application.score + '%' }}</span>
                </div>
            </div>
        </div>
        <scorecard v-if="reviewing" :application="application" @close="stopReview" :can-manage="canManage"></scorecard>
    </div>
</template>

<script>
import SimpleButton from './ui/SimpleButton.vue';
import SvgIcon from './ui/SvgIcon.vue';
import Scorecard from './Scorecard.vue';
import Score from './ui/Score.vue';
import ScoreProgress from "./ui/ScoreProgress.vue";
import ApplicationButton from "./ui/ApplicationButton.vue";
import ApplicationTitle from "./applications/ApplicationTitle.vue";

export default {
    components: {
        ApplicationTitle,
        ApplicationButton,
        ScoreProgress,
        SvgIcon,
        'simple-button': SimpleButton,
        'scorecard': Scorecard,
        'score': Score,
    },
    props: {
        application: Object,
        canManage: Boolean
    },
    data: function () {
        return {
            reviewing: false,
        }
    },
    computed: {
        hasScore() {
            return this.application.score !== null;
        }
    },
    methods: {
        startReview () {
            this.reviewing = true;
        },
        stopReview () {
            this.reviewing = false;
        },
    },
}
</script>
